import React, { memo, useCallback } from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { FILTER_NAME } from 'Pods/SearchPage/Shared/Tracking/constants'
import { useTrackFilterSelect } from 'Pods/SearchPage/Shared/Tracking/FilterTracking'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { removePriceRange, addPriceRange } from 'Pods/SearchPage/Store/actions/pricing'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'

import { priceRangeOptions } from './constants'

function RangeButtons() {
  const translate = useTranslate()

  const priceRanges = useSearchPageStore(state => state.priceRanges)
  const trackFilterSelect = useTrackFilterSelect()

  const handlePriceRangeClick = useCallback((priceRange) => {
    if (priceRanges && priceRanges.includes(priceRange)) {
      removePriceRange(priceRange)
    } else {
      trackFilterSelect(FILTER_NAME.PRICE, priceRange)
      addPriceRange(priceRange)
    }
  }, [priceRanges, trackFilterSelect])

  return (
    <div className="price-filter__range-buttons">
      {priceRangeOptions.map((option) => {
        const isSelected = priceRanges && priceRanges.includes(option.value)

        return (
          <Button
            key={option.value}
            type={isSelected ? 'primary' : 'secondary'}
            size="tiny"
            customClass="price-filter__range-button"
            isActive={isSelected}
            onClick={() => handlePriceRangeClick(option.value)}
          >
            {translate(`search_page.filters.price.ranges.${option.labelKey}`)}
          </Button>
        )
      })}
    </div>
  )
}

export default memo(RangeButtons)
